import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { FirebaseService } from '../services/firebase.service';

@Injectable()
export class AuthGuard implements CanActivate {
	
	constructor(private firebaseService: FirebaseService, private router: Router) { }
	
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		// console.log('guard', this.firebaseService.getCurrentUser());
		// if( this.firebaseService.getCurrentUser() ) {
		if( localStorage.getItem('currentUser') ) {
			return true;
		}
		// this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
		return false;
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/_guards/auth.guard.ts